<template>
    <div class="key_exchange">
		<el-dialog @close="showUserInfoPop" center :visible.sync="dialogVisible" width="780px" :show-close="false">
			<div class="dialog_title" slot="title">
				<div class="title_text">卡密兑换</div>
				<div class="close_btn" @click="dialogVisible = false"><img class="close_icon" src="../views/img/img_icon_51.png" alt="">关闭</div>
			</div>
			<div class="dialog_content">
                <div class="content_top">
                    <el-input v-model="card_no" placeholder="请在此输入卡密"></el-input><el-button type="info" @click="btnChange">确认兑换</el-button>
                </div>
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column prop="card_no" width="160" label="卡密"></el-table-column>
                    <el-table-column prop="days" width="140" label="时长"></el-table-column>
                    <el-table-column prop="bind_time" label="兑换时间"></el-table-column>
                    <el-table-column prop="status" width="70" align="right" :formatter="formatter" label="状态"></el-table-column>
                </el-table>
                <div class="dialog_tips"><span class="tips_text">仅显示最新会员兑换的五条记录</span></div>
            </div>
		</el-dialog>
    </div>
</template>
<script type="text/ecmascript-6">
    export default {
        data() {
            return {
                dialogVisible:false,
                card_no:"",
                tableData:[
                ]
            }
        },
        created() {
        
        },
        methods: {
            show(){
                this.dialogVisible = true;
                this.fetch()
            },
            formatter(row, column, cellValue, index){
                return row.status==1?"成功":"失败";
            },
            btnChange(){
                if(!this.card_no){
                    this.$toast("请输入卡密");
                    return
                }
                this.$http.post('/front/aixz/cardpwd/bind/',{card_no:this.card_no}).then(res =>{
                    if(res.status=='200'){
                        this.$toast("兑换成功");
						this.fetch()
                    }
                }).catch(res => {
                    this.$message({
                        message: res.result,
                        type: 'error'
                    });
                })
            },
            fetch(){
                this.$http.get('/front/aixz/cardpwd/bind/').then(res =>{
                    if(res.status=='200'){
						this.tableData = res.data.data_list
                    }
                })
            },
            showUserInfoPop(){
                this.$emit("showUserInfoPop")
            }
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .dialog_content{
        padding: 30px;
        .content_top{
            display: flex;
            padding-bottom: 27px;
            border-bottom: 1px solid #eee;
            .el-input{
                flex-grow: 1;
                margin-right: 12px;
            }
        }
        // .el-table{
        //     /deep/ tbody tr:first-child{
        //         color: #f00;
        //     }
        // }
        .dialog_tips{
            margin-top: 32px;
            font-size: 12px;
            line-height: 16px;
            text-align: center;
            .tips_text{
                color: #ccc;
                padding: 0 12px;
                position: relative;
                &::before,&::after{
                    content: "";
                    position: absolute;
                    display: block;
                    width: 210px;
                    height: 5px;
                    top: 5px;
                }
                &::before{
                    background-image: linear-gradient(to right,#fff,#ddd);
                    left: -210px;
                }
                &::after{
                    background-image: linear-gradient(to right,#ddd,#fff);
                    right: -210px;
                }
            }
        }
    }
</style>